module.exports = __webpack_public_path__ + "img/house-sm-right.544a49ac.png";